<script>
  import { mapState } from 'vuex'
  export default{
    data () {
      return {}
    },
    computed: {
      ...mapState({
        showHeader: state => state.app.showHeader,
        showMenu: state => state.app.showMenu,
        menuFolded: state => state.app.menuFolded
      })
    },
    mounted () {
      this._defaultLayout()
    },
    destroyed () {},
    methods: {
      _showHeader (bool) {
        this.$store.commit('APP/SHOW_HEADER', bool)
      },
      _showMenu (bool) {
        this.$store.commit('APP/SHOW_MENU', bool)
      },
      _menuFolded (bool, invert) {
        if (typeof invert !== 'undefined') {
          bool = !this.menuFolded
        }
        this.$store.commit('APP/MENU_FOLDED', bool)
      },
      _showFooter (bool) {
        this.$store.commit('APP/SHOW_FOOTER', bool)
      },
      _defaultLayout () {
        this._showMenu(true)
        this._showHeader(true)
        this._showFooter(true)
        this._menuFolded(true)
      }
    },
    components: {}
  }
</script>



// WEBPACK FOOTER //
// _base.vue?086d8125